// extracted by mini-css-extract-plugin
module.exports = {"welcomeContainer":"welcome_welcomeContainer__zfJwR","welcomeInfo":"welcome_welcomeInfo__luIkP","actionBtn":"welcome_actionBtn__2NUid"};